import { InstallationStatusCounter } from '~/api/models/installationStatusCounter';
import { StageDeviceInfo } from '~/api/models/stageDeviceInfo';

export interface StatisticItem {
  key: keyof InstallationStatusCounter;
  labelId: string;
  colorClass: string;
  skeletonPercentage: string;
  installationStatus?: StageDeviceInfo.InstallationStatusEnum;
}

export const STATISTICS_CONFIG: StatisticItem[] = [
  {
    key: 'targetNumber',
    labelId: 'intl-msg:campaign:statistics:targetVehicles',
    colorClass: '',
    skeletonPercentage: '10%'
  },
  {
    key: 'notStarted',
    installationStatus: StageDeviceInfo.InstallationStatusEnum.NotStarted,
    labelId: 'intl-msg:campaign:statistics:notStarted',
    colorClass: 'text-color-status-resting',
    skeletonPercentage: '10%'
  },
  {
    key: 'sentToDevice',
    installationStatus: StageDeviceInfo.InstallationStatusEnum.SentToDevice,
    labelId: 'intl-msg:campaign:statistics:sentToDevice',
    colorClass: 'text-color-status-resting',
    skeletonPercentage: '30%'
  },
  {
    key: 'inProgress',
    installationStatus: StageDeviceInfo.InstallationStatusEnum.InProgress,
    labelId: 'intl-msg:campaign:statistics:inProgress',
    colorClass: 'text-color-info',
    skeletonPercentage: '20%'
  },
  {
    key: 'updated',
    installationStatus: StageDeviceInfo.InstallationStatusEnum.Updated,
    labelId: 'intl-msg:campaign:statistics:updated',
    colorClass: 'text-color-success',
    skeletonPercentage: '20%'
  },
  {
    key: 'failed',
    installationStatus: StageDeviceInfo.InstallationStatusEnum.Failed,
    labelId: 'intl-msg:campaign:statistics:failed',
    colorClass: 'text-color-danger',
    skeletonPercentage: '20%'
  },
  {
    key: 'rebootPending',
    installationStatus: StageDeviceInfo.InstallationStatusEnum.RebootPending,
    labelId: 'intl-msg:campaign:statistics:rebootPending',
    colorClass: 'text-color-warning',
    skeletonPercentage: '40%'
  }
];
